export default class InventoryReceiptService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(inventoryReceipt, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt`, {
      body: JSON.stringify(inventoryReceipt),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, inventoryReceipt, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt/${id}`, {
      body: JSON.stringify(inventoryReceipt),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }

  async sync(deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryReceipt/import/sync?deleteMissing=${deleteMissing}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }
}